import React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import loadable from '@loadable/component'
import { Loader } from '../../../../../common/components';

// const EditUserSkillsScore = loadable(
//   () => import('./EditUserSkillsScore'), {
//       fallback: <Loader/>,
//   }
// );

const ListUserSkillsScore = loadable(
  () => import('./ListUserSkillsScore'), {
      fallback: <Loader/>,
  }
);
const ViewSkillProgress = loadable(
  () => import('./ViewSkillProgress'), {
      fallback: <Loader/>,
  }
);
const UserSkillsScoreRoutes = ({ t }) => {
  return [
    <Route
      key="view_user_skills_and_score"
      exact
      path="/view/:id/user-skills-score"
      element={<ListUserSkillsScore t={t} />}
    />,
    <Route
      key="view_user_skills_and_score"
      exact
      path="/view/:id/user-skills-score/:skillScoringParametersId"
      element={<ViewSkillProgress t={t} />}
    />
    // <Route
    //   key="edit_user_skills_and_score"
    //   exact
    //   path="/view/:id/user_skills_score/:scoreId/edit"
    //   element={<EditUserSkillsScore t={t} />}
    // />
  ];
};
UserSkillsScoreRoutes.propTypes = {
  t: PropTypes.func
};
export default UserSkillsScoreRoutes;
